import { EventEmitter, Injectable, Output } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { OperatingexpensesService } from './operatingexpenses.service';
import { ProjectService } from './project.service';

@Injectable()
export class CashFlowService {
  constructor(
    private http: Http,
    private toastr: ToastsManager,
    private projectService: ProjectService,
    private operatingexpensesService: OperatingexpensesService
  ) {
    this.projectId = localStorage.getItem('projectId');
    this.projectFlag = false;
    this.cashFlowFlag = false;
    // var data = {'projectId': this.projectId};
    // this.operatingexpensesService.updateCashFlow(data);
  }

  // This service provide data only to cash-flow records component and which is used in summary page to show cash flow tables

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Output() cashFlowEmit: EventEmitter<any> = new EventEmitter();

  @Output() projectEmitCashFlow: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  baseurl = environment.apiBaseUrl;

  projectId = '';

  projectName = '';

  year: number;

  show: boolean;

  start_up_month: number;

  maintenanceReserve: number;

  maintenanceReserveContribution: number;

  licensed_beds: number;

  operatingCapital: number;

  operatingCapitalInt: number;

  foodCost: number;

  foodCostInt: number;

  averageHourlyWage: number;

  averageHourlyWageInt: number;

  vacancyFactor: number;

  vacancyFactorInt: number;

  inflation_rate: number;

  inflation_rateInt: number;

  selectionType: string;

  occupiedTotal = 0;

  bedRate: number;

  bedRateInt: number;

  /** *************For 120 Months ************** */
  occupiedBedsArray = [];

  netOperatingExpensesArray = [];

  grossOperatingIncomeArray = [];

  grossOperatingIncomeTenYearsArray = [];

  opexTenYearsArray = [];

  profitLossArray = [];

  operatingArray = [];

  maintenanceArray = [];

  netCashFlowArray = [];

  totalOpex = [];

  totalOpexArray = [];

  cashInfusionArray = [];

  cashDistributionArray = [];

  debtServiceArray = [];

  /** ******************For Graph************ */

  GOIQuaterlyArray = [];

  OEQuaterlyArray = [];

  NOIQuaterlyArray = [];

  DSQuaterlyArray = [];

  PLQuaterlyArray = [];

  CIQuaterlyArray = [];

  CDQuaterlyArray = [];

  NCFQuaterlyArray = [];

  AOCQuaterlyArray = [];

  AMQuaterlyArray = [];

  /** ******************For Ten Year Totals ************ */

  GOITenArray = [];

  OETenArray = [];

  NOITenArray = [];

  DSTenArray = [];

  PLTenArray = [];

  netProfitPercentages = [];

  annualDebtServiceMultiples = [];

  CITenArray = [];

  CDTenArray = [];

  NCFTenArray = [];

  AOCTenArray = [];

  AMTenArray = [];

  /** ******************For Cumulative Year Totals ************ */

  GOIComArray = [];

  OEComArray = [];

  NOIComArray = [];

  DSComArray = [];

  PLComArray = [];

  debtServiceMultiplesCumulative = [];

  netProfitPercentagesCumulative = [];

  CIComArray = [];

  CDComArray = [];

  NCFComArray = [];

  AOCComArray = [];

  AMComArray = [];

  projectFlag: boolean;

  cashFlowFlag: boolean;

  // TO GET SAVED PROJECT DATA FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectId = localStorage.getItem('projectId');
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.selectionType = projectData.data[0].selection_type;
      this.start_up_month = projectData.data[0].start_up_month;
      this.licensed_beds = projectData.data[0].licensed_beds;

      this.averageHourlyWage = projectData.data[0].average_hourly_wage;
      this.averageHourlyWageInt = projectData.data[0].average_hourly_wage;

      this.inflation_rate = projectData.data[0].inflation_rate;
      this.inflation_rateInt = projectData.data[0].inflation_rate;

      if (this.selectionType === 'other') {
        this.bedRate = projectData.data[0].bed_rate_other;
        this.bedRateInt = projectData.data[0].bed_rate_other;
        this.show = false;
      } else {
        this.bedRate = projectData.data[0].bed_rate;
        this.bedRateInt = projectData.data[0].bed_rate_other;
        this.show = true;
      }

      this.foodCost = projectData.data[0].food_cost;
      this.foodCostInt = projectData.data[0].food_cost;

      this.vacancyFactor = projectData.data[0].vacancy_factor;
      this.vacancyFactorInt = projectData.data[0].vacancy_factor;

      this.operatingCapital = projectData.data[0].operating_capital;
      this.operatingCapitalInt = projectData.data[0].operating_capital;

      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.maintenanceReserveContribution = projectData.data[0].maintenance_reserve_contribution;
      this.projectFlag = true;
    });
  }

  // get data of 120 months from db and set into arrays for ten year, 120 months and for graph also for summary page only
  getCashFlow(callback?: any) {
    this.projectId = localStorage.getItem('projectId');
    const data = { projectId: this.projectId };

    this.projectService.getOccupiedBeds(data).subscribe((res) => {
      this.occupiedBedsArray = [];
      this.netOperatingExpensesArray = [];
      this.grossOperatingIncomeArray = [];
      this.profitLossArray = [];
      this.operatingArray = [];
      this.maintenanceArray = [];
      this.netCashFlowArray = [];
      this.totalOpexArray = [];
      this.cashInfusionArray = [];
      this.cashDistributionArray = [];
      this.debtServiceArray = [];

      this.GOIComArray = [];
      this.OEComArray = [];
      this.NOIComArray = [];
      this.DSComArray = [];
      this.PLComArray = [];
      this.debtServiceMultiplesCumulative = [];
      this.netProfitPercentagesCumulative = [];
      this.CIComArray = [];
      this.CDComArray = [];
      this.NCFComArray = [];
      this.AOCComArray = [];
      this.AMComArray = [];

      this.GOITenArray = [];
      this.OETenArray = [];
      this.NOITenArray = [];
      this.DSTenArray = [];
      this.PLTenArray = [];
      this.netProfitPercentages = [];
      this.annualDebtServiceMultiples = [];
      this.CITenArray = [];
      this.CDTenArray = [];
      this.NCFTenArray = [];
      this.AOCTenArray = [];
      this.AMTenArray = [];

      this.GOIQuaterlyArray = [];
      this.OEQuaterlyArray = [];
      this.NOIQuaterlyArray = [];
      this.DSQuaterlyArray = [];
      this.PLQuaterlyArray = [];
      this.CIQuaterlyArray = [];
      this.CDQuaterlyArray = [];
      this.NCFQuaterlyArray = [];
      this.AOCQuaterlyArray = [];
      this.AMQuaterlyArray = [];

      this.occupiedBedsArray = res.data;
      // this.occupiedBedsArray = [...res.data];
      // console.log("occupiedBedsArray:- ",this.occupiedBedsArray);
      // Calculate GOI for monthly and yearly
      let i = 0;
      let iquater = 0;
      let iten = 0;
      let additionGOI = 0;
      let additionthreeGOI = 0;
      let additionfiveGOI = 0;
      let additionsevenGOI = 0;
      let additiontenGOI = 0;

      this.occupiedBedsArray.forEach((element) => {
        this.grossOperatingIncomeArray[i] = element.goi;

        additionGOI += element.goi;
        if ((i + 1) % 3 === 0) {
          this.GOIQuaterlyArray[iquater] = additionGOI;
          additionGOI = 0;
          iquater++;
        }
        additiontenGOI += element.goi;
        if ((i + 1) % 12 === 0) {
          this.GOITenArray[iten] = additiontenGOI;
          additiontenGOI = 0;
          iten++;
        }
        i++;
      });
      // Cumulative Calculations
      additionthreeGOI = this.GOITenArray[0] + this.GOITenArray[1] + this.GOITenArray[2];
      additionfiveGOI = additionthreeGOI + this.GOITenArray[3] + this.GOITenArray[4];
      additionsevenGOI = additionfiveGOI + this.GOITenArray[5] + this.GOITenArray[6];
      additiontenGOI =
        additionsevenGOI + this.GOITenArray[7] + this.GOITenArray[8] + this.GOITenArray[9];
      this.GOIComArray.push(additionthreeGOI, additionfiveGOI, additionsevenGOI, additiontenGOI);

      // Calculate Less:Operating Income for monthly and yearly
      let o = 0;
      let oten = 0;
      let oquater = 0;
      let additionOE = 0;
      let additionthreeOE = 0;
      let additionfiveOE = 0;
      let additionsevenOE = 0;
      let additiontenOE = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.totalOpexArray[o] = -element.total_opex;

        additionOE += -element.total_opex;
        if ((o + 1) % 3 === 0) {
          this.OEQuaterlyArray[oquater] = additionOE;
          additionOE = 0;
          oquater++;
        }
        additiontenOE += -element.total_opex;
        if ((o + 1) % 12 === 0) {
          this.OETenArray[oten] = additiontenOE;
          additiontenOE = 0;
          oten++;
        }
        o++;
      });
      // Cumulative Calculations
      additionthreeOE = this.OETenArray[0] + this.OETenArray[1] + this.OETenArray[2];
      additionfiveOE = additionthreeOE + this.OETenArray[3] + this.OETenArray[4];
      additionsevenOE = additionfiveOE + this.OETenArray[5] + this.OETenArray[6];
      additiontenOE =
        additionsevenOE + this.OETenArray[7] + this.OETenArray[8] + this.OETenArray[9];
      this.OEComArray.push(additionthreeOE, additionfiveOE, additionsevenOE, additiontenOE);

      // Calculate Net Operating Income for monthly and yearly
      let b = 0;
      let bten = 0;
      let bquater = 0;
      let additionNOI = 0;
      let additionthreeNOI = 0;
      let additionfiveNOI = 0;
      let additionsevenNOI = 0;
      let additiontenNOI = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.netOperatingExpensesArray[b] = element.goi + -element.total_opex;

        additionNOI += this.netOperatingExpensesArray[b];
        if ((b + 1) % 3 === 0) {
          this.NOIQuaterlyArray[bquater] = additionNOI;
          additionNOI = 0;
          bquater++;
        }
        additiontenNOI += this.netOperatingExpensesArray[b];
        if ((b + 1) % 12 === 0) {
          this.NOITenArray[bten] = additiontenNOI;
          additiontenNOI = 0;
          bten++;
        }
        b++;
      });
      // Cumulative Calculations
      additionthreeNOI = this.NOITenArray[0] + this.NOITenArray[1] + this.NOITenArray[2];
      additionfiveNOI = additionthreeNOI + this.NOITenArray[3] + this.NOITenArray[4];
      additionsevenNOI = additionfiveNOI + this.NOITenArray[5] + this.NOITenArray[6];
      additiontenNOI =
        additionsevenNOI + this.NOITenArray[7] + this.NOITenArray[8] + this.NOITenArray[9];
      this.NOIComArray.push(additionthreeNOI, additionfiveNOI, additionsevenNOI, additiontenNOI);

      // Calculate Debt Service for monthly and yearly
      let c = 0;
      let cten = 0;
      let cquater = 0;
      let additionDS = 0;
      let additionthreeDS = 0;
      let additionfiveDS = 0;
      let additionsevenDS = 0;
      let additiontenDS = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.debtServiceArray[c] = element.debt;

        additionDS += element.debt;
        if ((c + 1) % 3 === 0) {
          this.DSQuaterlyArray[cquater] = additionDS;
          additionDS = 0;
          cquater++;
        }
        additiontenDS += element.debt;
        if ((c + 1) % 12 === 0) {
          this.DSTenArray[cten] = additiontenDS;
          additiontenDS = 0;
          cten++;
        }
        c++;
      });
      // Cumulative Calculations
      additionthreeDS = this.DSTenArray[0] + this.DSTenArray[1] + this.DSTenArray[2];
      additionfiveDS = additionthreeDS + this.DSTenArray[3] + this.DSTenArray[4];
      additionsevenDS = additionfiveDS + this.DSTenArray[5] + this.DSTenArray[6];
      additiontenDS =
        additionsevenDS + this.DSTenArray[7] + this.DSTenArray[8] + this.DSTenArray[9];
      this.DSComArray.push(additionthreeDS, additionfiveDS, additionsevenDS, additiontenDS);

      //
      // Calculate the debt service coverage as shown on the Financial Reports. It is just
      // the NOI / debt service (assuming debt service is not zero). We need this on an annual basis.
      //
      for (let year = 0; year < this.NOITenArray.length; year++) {
        const debtServiceMultiple = this.NOITenArray[year] / this.DSTenArray[year];
        this.annualDebtServiceMultiples.push(
          Number.isFinite(debtServiceMultiple) ? debtServiceMultiple : 0
        );
      }
      for (let index = 0; index < 4; index++) {
        const debtServiceMultiple = this.NOIComArray[index] / this.DSComArray[index];
        this.debtServiceMultiplesCumulative.push(
          Number.isFinite(debtServiceMultiple) ? debtServiceMultiple : 0
        );
      }

      // Calculate CASH INFUSION for monthly and yearly
      let d = 0;
      let dten = 0;
      let dquater = 0;
      let additionCI = 0;
      let additionthreeCI = 0;
      let additionfiveCI = 0;
      let additionsevenCI = 0;
      let additiontenCI = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.cashInfusionArray[d] = element.cash_infusion;

        additionCI += element.cash_infusion;
        if ((d + 1) % 3 === 0) {
          this.CIQuaterlyArray[dquater] = additionCI;
          additionCI = 0;
          dquater++;
        }
        additiontenCI += element.cash_infusion;
        if ((d + 1) % 12 === 0) {
          this.CITenArray[dten] = additiontenCI;
          additiontenCI = 0;
          dten++;
        }
        d++;
      });
      // Cumulative Calculations
      additionthreeCI = this.CITenArray[0] + this.CITenArray[1] + this.CITenArray[2];
      additionfiveCI = additionthreeCI + this.CITenArray[3] + this.CITenArray[4];
      additionsevenCI = additionfiveCI + this.CITenArray[5] + this.CITenArray[6];
      additiontenCI =
        additionsevenCI + this.CITenArray[7] + this.CITenArray[8] + this.CITenArray[9];
      this.CIComArray.push(additionthreeCI, additionfiveCI, additionsevenCI, additiontenCI);

      // Calculate CASH DISTRIBUTION for monthly and yearly
      // let e=0;
      let eten = 0;
      let equater = 0;
      let additionCD = 0;
      let additionthreeCD = 0;
      let additionfiveCD = 0;
      let additionsevenCD = 0;
      let additiontenCD = 0;
      // this.cashDistributionArray[0] = 0;
      for (let e = 0; e < this.occupiedBedsArray.length; e++) {
        // this.cashDistributionArray[e+1] = this.occupiedBedsArray[e].cash_distribution;
        // amitcodedhome
        this.cashDistributionArray[e] = this.occupiedBedsArray[e].cash_distribution;

        additionCD += this.cashDistributionArray[e];
        if (e % 3 === 0) {
          this.CDQuaterlyArray[equater] = additionCD;
          additionCD = 0;
          equater++;
        }
        additiontenCD += this.cashDistributionArray[e];
        if ((e + 1) % 12 === 0) {
          this.CDTenArray[eten] = additiontenCD;
          additiontenCD = 0;
          eten++;
        }
      }
      // console.log('this.CDTenArray',this.CDTenArray);

      // this.occupiedBedsArray.forEach(element => {
      //   this.cashDistributionArray[e]=  element.cash_distribution;
      //   additionCD += element.cash_distribution;
      //   if((e+1)%3 === 0){
      //       this.CDQuaterlyArray[equater] = additionCD;
      //       additionCD = 0;
      //       equater++;
      //   }
      //   additiontenCD += element.cash_distribution;
      //   if((e+1)%12 === 0){
      //       this.CDTenArray[eten] = additiontenCD;
      //       additiontenCD = 0;
      //       eten++;
      //   }
      //   e++;
      // });
      // Cumulative Calculations
      additionthreeCD = this.CDTenArray[0] + this.CDTenArray[1] + this.CDTenArray[2];
      additionfiveCD = additionthreeCD + this.CDTenArray[3] + this.CDTenArray[4];
      additionsevenCD = additionfiveCD + this.CDTenArray[5] + this.CDTenArray[6];
      additiontenCD =
        additionsevenCD + this.CDTenArray[7] + this.CDTenArray[8] + this.CDTenArray[9];
      this.CDComArray.push(additionthreeCD, additionfiveCD, additionsevenCD, additiontenCD);

      // Calculate PL for monthly and yearly
      let jten = 0;
      let jquater = 0;
      let additionPL = 0;
      let additionthreePL = 0;
      let additionfivePL = 0;
      let additionsevenPL = 0;
      let additiontenPL = 0;
      let additionAOC = 0;
      let additionthreeAOC = 0;
      let additionfiveAOC = 0;
      let additionsevenAOC = 0;
      let additiontenAOC = 0;
      for (let j = 0; j < 120; j++) {
        this.profitLossArray[j] = this.netOperatingExpensesArray[j] + -this.debtServiceArray[j];
        if (j === 0) {
          this.operatingArray[j] =
            +this.netOperatingExpensesArray[j] + -this.debtServiceArray[j] + +this.operatingCapital;
        } else {
          this.operatingArray[j] =
            +this.netOperatingExpensesArray[j] +
            -this.debtServiceArray[j] +
            +this.operatingArray[j - 1];
        }
        additionPL += this.profitLossArray[j];
        additionAOC += this.operatingArray[j];
        if ((j + 1) % 3 === 0) {
          this.PLQuaterlyArray[jquater] = additionPL;
          additionPL = 0;
          this.AOCQuaterlyArray[jquater] = additionAOC;
          additionAOC = 0;
          jquater++;
        }

        additiontenPL += this.profitLossArray[j];
        additiontenAOC += this.operatingArray[j];
        if ((j + 1) % 12 === 0) {
          this.PLTenArray[jten] = additiontenPL;
          this.netProfitPercentages[jten] = this.PLTenArray[jten] / this.GOITenArray[jten];
          additiontenPL = 0;
          this.AOCTenArray[jten] =
            +this.netOperatingExpensesArray[j] +
            -this.debtServiceArray[j] +
            +this.operatingArray[j - 1];
          additiontenAOC = 0;
          jten++;
        }
      }
      // Cumulative Calculations
      additionthreePL = this.PLTenArray[0] + this.PLTenArray[1] + this.PLTenArray[2];
      additionfivePL = additionthreePL + this.PLTenArray[3] + this.PLTenArray[4];
      additionsevenPL = additionfivePL + this.PLTenArray[5] + this.PLTenArray[6];
      additiontenPL =
        additionsevenPL + this.PLTenArray[7] + this.PLTenArray[8] + this.PLTenArray[9];
      this.PLComArray.push(additionthreePL, additionfivePL, additionsevenPL, additiontenPL);
      this.netProfitPercentagesCumulative.push(
        additionthreePL / additionthreeGOI,
        additionfivePL / additionfiveGOI,
        additionsevenPL / additionsevenGOI,
        additiontenPL / additiontenGOI
      );
      additionthreeAOC = this.AOCTenArray[0] + this.AOCTenArray[1] + this.AOCTenArray[2];
      additionfiveAOC = additionthreeAOC + this.AOCTenArray[3] + this.AOCTenArray[4];
      additionsevenAOC = additionfiveAOC + this.AOCTenArray[5] + this.AOCTenArray[6];
      additiontenAOC =
        additionsevenAOC + this.AOCTenArray[7] + this.AOCTenArray[8] + this.AOCTenArray[9];
      this.AOCComArray.push(additionthreeAOC, additionfiveAOC, additionsevenAOC, additiontenAOC);

      // Calculate NCF for monthly and yearly
      let mten = 0;
      let mquater = 0;
      let additionNCF = 0;
      let additionthreeNCF = 0;
      let additionfiveNCF = 0;
      let additionsevenNCF = 0;
      let additiontenNCF = 0;
      for (let m = 0; m < 120; m++) {
        this.netCashFlowArray[m] =
          this.profitLossArray[m] - this.cashDistributionArray[m] + this.cashInfusionArray[m];

        additionNCF += this.netCashFlowArray[m];
        if ((m + 1) % 3 === 0) {
          this.NCFQuaterlyArray[mquater] = additionNCF;
          additionNCF = 0;
          mquater++;
        }

        additiontenNCF += this.netCashFlowArray[m];
        if ((m + 1) % 12 === 0) {
          this.NCFTenArray[mten] = additiontenNCF;
          additiontenNCF = 0;
          mten++;
        }
      }
      // Cumulative Calculations
      additionthreeNCF = this.NCFTenArray[0] + this.NCFTenArray[1] + this.NCFTenArray[2];
      additionfiveNCF = additionthreeNCF + this.NCFTenArray[3] + this.NCFTenArray[4];
      additionsevenNCF = additionfiveNCF + this.NCFTenArray[5] + this.NCFTenArray[6];
      additiontenNCF =
        additionsevenNCF + this.NCFTenArray[7] + this.NCFTenArray[8] + this.NCFTenArray[9];
      this.NCFComArray.push(additionthreeNCF, additionfiveNCF, additionsevenNCF, additiontenNCF);

      // Calculate MR for monthly and yearly
      let l = 0;
      let lten = 0;
      let lquater = 0;
      let additionAMQ = 0;
      let additionthreeAMQ = 0;
      let additionfiveAMQ = 0;
      let additionsevenAMQ = 0;
      let additiontenAMQ = 0;
      this.grossOperatingIncomeArray.forEach((element) => {
        let calculatedValue =
          +this.maintenanceReserve +
          +Math.round((this.maintenanceReserveContribution / 100) * element) -
          this.occupiedBedsArray[l].repairs_maintenance;
        calculatedValue = isNaN(calculatedValue) ? 0 : calculatedValue;
        if (l === 0) {
          this.maintenanceArray[l] = calculatedValue;
        } else {
          let calculatedValue =
            +this.maintenanceArray[l - 1] +
            +Math.round((this.maintenanceReserveContribution / 100) * element) -
            this.occupiedBedsArray[l].repairs_maintenance;
          calculatedValue = isNaN(calculatedValue) ? 0 : calculatedValue;
          this.maintenanceArray[l] = calculatedValue;
        }

        additionAMQ += this.maintenanceArray[l];
        if ((l + 1) % 3 === 0) {
          this.AMQuaterlyArray[lquater] = additionAMQ;
          additionAMQ = 0;
          lquater++;
        }

        additiontenAMQ += this.maintenanceArray[l];
        if ((l + 1) % 12 === 0) {
          this.AMTenArray[lten] = this.maintenanceArray[l]; // additiontenAMQ;
          additiontenAMQ = 0;
          lten++;
        }
        l++;
      });
      // Cumulative Calculations
      additionthreeAMQ = this.AMTenArray[0] + this.AMTenArray[1] + this.AMTenArray[2];
      additionfiveAMQ = additionthreeAMQ + this.AMTenArray[3] + this.AMTenArray[4];
      additionsevenAMQ = additionfiveAMQ + this.AMTenArray[5] + this.AMTenArray[6];
      additiontenAMQ =
        additionsevenAMQ + this.AMTenArray[7] + this.AMTenArray[8] + this.AMTenArray[9];
      this.AMComArray.push(additionthreeAMQ, additionfiveAMQ, additionsevenAMQ, additiontenAMQ);
      // this.cashFlowEmit.emit({'cashFlowEmit':true});
      this.cashFlowFlag = true;
      if (callback) {
        const data = {
          grossOperatingIncomeArray: this.grossOperatingIncomeArray,
          totalOpexArray: this.totalOpexArray,
          netOperatingExpensesArray: this.netOperatingExpensesArray,
          debtServiceArray: this.debtServiceArray,
          profitLossArray: this.profitLossArray,
          cashInfusionArray: this.cashInfusionArray,
          cashDistributionArray: this.cashDistributionArray,
          netCashFlowArray: this.netCashFlowArray,
          operatingArray: this.operatingArray,
          maintenanceArray: this.maintenanceArray,
          start_up_month: this.start_up_month,
        };
        callback(data);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/cashflow.service.ts